export enum DealParticipantType {
  Undefined = 0,
  Buyer = 1,
  Seller = 2
}
